import { React, useEffect, useState ,Fragment} from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import Swal from 'sweetalert2'
import {
  bannerBgColor,
  tabMenuColor,
  sidebarColor,
  logoWeb,
  tabMenuActionColor,
  textColor,
  textColorActive,
} from "../components/ThemeConfig/menuConfig";
import { useMenuDynamicStyles } from "../components/useDynamic/menu_DynamicStyles";
import { fetchUserDataList, fetchProfileDataList } from "../api/User_api";
import Loading from "../components/loading/Loading";
import { setTimeOutSync } from "../utils/setTimeout";
import { getAllRole, createRole, getRole, getRoleByID, updateRoleByID} from "../api/role_api";
import { sidebarMenu } from "../utils/const";

function Menu({ parentmenu, activemenu }) {
  useMenuDynamicStyles(
    bannerBgColor,
    tabMenuColor,
    sidebarColor,
    tabMenuActionColor,
    textColor,
    textColorActive
  ); 

  const [editId, setEditId] = useState(null);
  const [selectPermission, setSelectPermission] = useState([]);

  const [dataUser, setDataUser] = useState({
    role: null
});
  
  // let sidebarMenu = [
  //   { text:'Shortcuts',name:'infoShortcuts',icon :'ic-shortcut.png',path:'infoShortcuts',key:'SHORTCUTS' },
  //   { text:'Home',name:'infoHome',icon :'ic-home.png',path:'infoHome',key:'HOME' },
  //   { text:'Banner',name:'infoBanner',icon :'ic-hero-banner.png', key: 'BANNER', 
  //     subMenu:[
  //       {text:'Hero Banner',name:'infoHeroBanner',
  //         subMenu:[
  //           {text:'Hero Banner Home',name:'infoHeroBannerHome',path:'infoHeroBannerHome'},
  //           {text:'Hero Banner Officer',name:'infoHeroBannerOfficer',path:'infoHeroBannerOfficer'},
  //           {text:'Hero Banner Condo',name:'infoHeroBannerCondo',path:'infoHeroBannerCondo'},
  //           {text:'Hero Banner Retail Center',name:'infoHeroBannerRetail',path:'infoHeroBannerRetail'},
  //           {text:'Hero Banner Promotion',name:'infoHeroBannerPromotion',path:'infoHeroBannerPromotion'},
  //         ]
  //       },
  //       {text:'Head Banner',name:'infoHeadBanner',path:'infoHeadBanner'}
  //     ] 
  //   },
  //   { text:'Business',name:'infoBusiness',icon :'ic-business.png', key:'BUSINESS',
  //     subMenu:[
  //       {text:'Office Building',name:'infoOfficeBuilding',
  //         subMenu:[
  //           {text:'CRC Tower',name:'infoCRCTower',path:'infoCRCTower'},
  //           {text:'M Thai Tower',name:'infoMThaiTower',path:'infoMThaiTower'},
  //           {text:'Capital Tower',name:'infoCapitalTower',path:'infoCapitalTower'},
  //         ]
  //       },
  //       {text:'Retail Center',name:'infoRetailCenter',
  //         subMenu:[
  //           {text:'Retail Center Detail',name:'infoRetailCenterDetail',path:'infoRetailCenterDetail'},
  //           {text:'Directory',name:'infoDirectory',path:'infoDirectory'},
  //         ]
  //       },
  //       {text:'Condominium',name:'infoCondominium',
  //         subMenu:[
  //           {text:'Condo Manage',name:'infoCondoManage',path:'infoCondoManage'},
  //           {text:'Condo For Rent',name:'infoCondoRent',path:'infoCondoRent'},
  //           {text:'Condo For Sale',name:'infoCondoSale',path:'infoCondoSale'},
  //         ]
  //       },
  //     ] 
  //   },
  //   { text:'Promotion & Privilege',name:'infoPromotionPrivilege',icon :'ic-promotionprivilege.png',key:'PROMOTION_PRIVILEGE',
  //     subMenu:[
  //       {text:'Promotion',name:'infoPromotion',path:'infoPromotion'},
  //       {text:'Privilege',name:'infoPrivilege',path:'infoPrivilege'}
  //     ] 
  //   },
  //   { text:'News & Event',name:'infoNewsEvent',icon :'ic-newsevent.png',key:'NEWS_EVENT',
  //     subMenu:[
  //       {text:'News',name:'infoNews',path:'infoNews'},
  //       {text:'Event',name:'infoEvent',path:'infoEvent'}
  //     ] 
  //   },
  //   { text:'Career Job',name:'infoCareerJob',icon :'ic-career.png',key:'CAREER',
  //     subMenu:[
  //       {text:'Content Career',name:'infoContentCareer',path:'infoContentCareer'},
  //       {text:'Job Position',name:'infoJobPosition',path:'infoJobPosition'},
  //       {text:'Job Applicants',name:'infoJobApplicants',path:'infoJobApplicants'}
  //     ] 
  //   },
  //   { text:'Contact Us',name:'infoContactUs',icon :'ic-contact-us.png',path:'infoContactUs',key:'CONTACT_US' },
  //   { text:'About Us',name:'infoAboutUs',icon :'ic-about-us.png',path:'infoAboutUs' ,key:'ABOUT_US' },
  //   { text:'Open Tendering Project',name:'infoTendering',icon :'ic-tendering.png',key:'OPEN_TENDERING',
  //     subMenu:[
  //       {text:'Bidding Information',name:'infoBiddingInformation',path:'infoBiddingInformation'},
  //       {text:'Bidding Winning',name:'infoBiddingWinning',path:'infoBiddingWinning'}
  //     ] 
  //   },
  //   { text:'Our Service & Privilege',name:'infoOurService',icon :'ic-our-service.png',key:'SERVICE_PRIVILEGE',
  //     subMenu:[
  //       {text:'ASP Customer Care',name:'infoCustomerCare',path:'infoCustomerCare'},
  //       {text:'ASP Club Lounge',name:'infoClubLounge',path:'infoClubLounge'},
  //       {text:'Shuttle Bus Service',name:'infoShuttleBus',path:'infoShuttleBus'},
  //       {text:'Carpark & Security Service',name:'infoCarpark',path:'infoCarpark'}
  //     ] 
  //   },
  //   { text:'Social Media',name:'infoSocialMedia',icon :'ic-social-media.png',path:'infoSocialMedia',key:'SOCIAL_MEDIA' },
  //   { text:'Admin User',name:'infoAdminUser',icon :'ic-users.png',key:'ADMIN_USER',
  //     subMenu:[
  //       {text:'User Manage',name:'infoUserManage',path:'infoUserManage'},
  //       {text:'Role Manage',name:'infoRoleManage',path:'infoRoleManage'},
  //     ] 
  //   },
  // ];
 


  const sidebarOpenArr = sidebarMenu.map((item) => ({
    isopen: item.name === parentmenu,
    key: item.key,
    sideopenSub: item.subMenu?.map((itemSub) => {
      // console.log('itemSub',itemSub)
      return({
        isopen: itemSub.subMenu?.some(x=>x.name === activemenu) ?? false
      })
   }) ?? []
  }));
  const [isLoading, setLoading] = useState(false);
  const [isProfileRoleGet, setIsProfileRoleGet] = useState(false);
  const [dataProfile, setDataProfile] = useState({
    firstname: null,
    lastname: null,
  });
  const [sideopen, setsideopen] = useState(sidebarOpenArr);

  function menuclick(e, index) {
    if (e.target.outerHTML.includes("headermenu")) {
      let currentopen = sideopen;
      currentopen[index].isopen = !sideopen[index].isopen;
      for (let i=0;i<currentopen[index].sideopenSub.length;i++) {
        currentopen[index].sideopenSub[i].isopen = false
      }
      setsideopen([...currentopen]);
    }
  }

  const navigate = useNavigate();

  const logout = () => {
    Swal.fire({
      iconHtml: '<img src="https://img2.pic.in.th/pic/ic-logout.png">',
      title: 'Logout',
      html: 'Do you want to log out?<br/>คุณต้องการออกจากระบบใช่หรือไม่',
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "CANCLE",
      reverseButtons: true
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        sessionStorage.removeItem("tokenBackoffice");
        localStorage.removeItem("tokenBackoffice");
        navigate("/login");
      } else if (result.dismiss) {}
    });
  };

 function menuclickSub(e, index, indexSub) {
  e.stopPropagation();
  if (e.target.outerHTML.includes("headermenu")) {
    let currentopen = sideopen;
    currentopen[index].isopen = true
    currentopen[index].sideopenSub[indexSub].isopen = !sideopen[index].sideopenSub[indexSub].isopen;
    setsideopen([...currentopen]);
  }
  }

  async function getDataProfile() {
    try {
      setLoading(true);
      setTimeOutSync(() => setLoading(false)).then(async () => {
        let response = await fetchProfileDataList();

        setsideopen(sideopen.filter(allMenu => {
          // Find the corresponding item in response.role.menu_lists
          const roleMenu = response.role.menu_lists.find(menu => menu.key === allMenu.key);
          // Return true if the item is found, false otherwise
          return roleMenu !== undefined;
        }))
        setDataProfile({
          ...dataProfile,
          firstname: response.firstname,
          lastname: response.lastname,
        });
        setIsProfileRoleGet(true)
        setLoading(false);

      });      
    } catch (error) {}
  }
  useEffect(() => {
    let userAgent = navigator.userAgent;
    let browserName;
    if (
      userAgent.includes("android") ||
      userAgent.includes("iPhone") ||
      userAgent.includes("iPad")
    ) {
      browserName = "mobile";
    } else if (userAgent.includes("Linux")) {
      browserName = "tablet";
    }

    if (
      (browserName === "mobile" || browserName === "tablet") &&
      window.innerWidth < 1334
    ) {
      //setsideShow(false)
      $("#bodyid").removeClass("sidebar-open");
      $("#bodyid").addClass("sidebar-closed sidebar-collapse");
      $("#sidetest").addClass("d-none");
    }
    getDataProfile();
  }, []);

  return (
    <>
    {isLoading ? <Loading /> : ""}
      {" "}
      <aside className="main-sidebar sidebar-primary elevation-4" id="sidetest">
        {/* Brand Logo */}
        <div className="brand-link background-primary py-2">
          <div className="row">
            <div className="col-12 text-center">
              <img
                src={logoWeb}
                className="ml-4-style"
                alt=""
              />
            </div>
          </div>
        </div>
        {/* Menu */}
        <div className="sidebar">
          <hr className="text-black mg-card-user" />
          {/* Sidebar Menu */}
          <nav className="mt-2 fontReg font-size03">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              //data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
             
              {isProfileRoleGet && sidebarMenu.filter(allMenu => {
                const roleMenu = sideopen.find(sideopen => sideopen.key === allMenu.key);
                return roleMenu !== undefined;
              }).map((item,idx) => (
               <Fragment key={idx}>
               {!item.subMenu ? (
                // menu เดียว
                  <li className={`nav-item `}>
                    <Link
                      as={Link}
                      to={"/"+item.path}
                      className={`nav-link  ${
                        activemenu === item.name ? "active" : ""
                      }`}
                    >
                      <img
                        src={"assets/iconMenu/"+item.icon}
                        width="20px"
                        className="mr-3 mbs-4 mg-3-style"
                        alt=""
                      />
                      <p className="font-weight-bold">{item.text}</p>
                    </Link>
                  </li> ):               
                  ( <li
                    className={`nav-item  ${
                      sideopen[idx].isopen 
                      ||sideopen[idx].sideopenSub?.some(x=>x.isopen)
                      ? "menu-is-opening menu-open" : ""
                    } `}
                    onClick={(event) => menuclick(event, idx)}
                  >
                    <div
                      className={`nav-link headermenu ${
                        parentmenu === item.name ? "active" : ""
                      } `}
                    >
                      <img
                        src={"assets/iconMenu/"+item.icon}
                        width="20px"
                        className="mr-3 mbs-4 mg-3-style" alt=""
                      />
                      <p className={"font-weight-bold headermenu"}>
                        {item.text}
                        <i
                          className={`right fas fa-angle-left headermenu ${
                            sideopen[idx].isopen 
                            ||sideopen[idx].sideopenSub?.some(x=>x.isopen)
                            ? "rotate-90" : "rotate0"
                          }`}
                        />
                      </p>
                    </div>
                    <ul className={`nav nav-treeview`}>
                    {item.subMenu.map((itemSub,idxSub) => {
                      if(!itemSub.subMenu){ 
                        // console.log('item',item)
                        return(
                        <Fragment key={idxSub}>
                        <li className="nav-item" key={idxSub}>
                          <Link
                            as={Link}
                            to={"/"+itemSub.path}
                            className={`nav-link font-weight-bold menu-single d-flex align-items-center px-4 ${
                              activemenu === itemSub.name ? "active" : ""
                            }`}
                          >
                            <p>{itemSub.text}</p>
                          </Link>
                        </li> 
                        </Fragment>
                        )
                      }
                      else{
                        return(
                        <Fragment key={idxSub}>
                          <li
                            className={`nav-item  ${
                              sideopen[idx].sideopenSub[idxSub].isopen ? "menu-is-opening menu-open" : ""
                            } `}
                            onClick={(event) => menuclickSub(event, idx, idxSub)}
                          >
                            <div
                              className={`nav-link headermenu ${
                                itemSub.subMenu.some(x=>x.name === activemenu) ? "active" : ""
                              } `}
                            >
                              <p className={"font-weight-bold headermenu"}>
                                {itemSub.text}
                                <i
                                  className={`right fas fa-angle-left headermenu ${
                                    sideopen[idx].sideopenSub[idxSub].isopen ? "rotate-90" : "rotate0"
                                  }`}
                                />
                              </p>
                            </div>
                            <ul className={`nav nav-treeview`}>
                              {itemSub.subMenu.map((itemSub2,idxSub2) => 
                                <Fragment key={idxSub2}>
                                <li className="nav-item" key={idxSub2}>
                                  <Link
                                    as={Link}
                                    to={"/"+itemSub2.path}
                                    className={`nav-link d-flex align-items-center px-4 ${
                                      activemenu === itemSub2.name ? "active" : ""
                                    }`}
                                  >
                                    <p>{itemSub2.text}</p>
                                  </Link>
                                </li> 
                                </Fragment>
                                )}
                          </ul>
                          </li> 
                        </Fragment>
                        )
                      }
                    }
                    )}
                                    
                    </ul>
                  </li>
                 )
              }
              </Fragment>
              ))}
             
                  
            </ul>
          </nav>
          {/* /.sidebar-menu */}
          <button onClick={() => logout()} className="logout-menu font-weight-bold fontReg colorGray03 font-size03">
            <img src="assets/iconMenu/ic-logout.png" width="20px" className="mr-3 mbs-4 mg-3-style" alt="" /><font>Log Out</font>
          </button>
        </div>
        {/* /.sidebar */}
      </aside>
    </>
  );
}

export default Menu;
